import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const NotificationBase = (
  <path
    fill='currentColor'
    d='M13.684 20.273c0 .95-.758 1.727-1.684 1.727-.926 0-1.684-.777-1.684-1.727zM12 3c1.145 0 2.075.934 2.105 2.101 2.487.9 4.21 3.322 4.21 6.104v4.392l1.192 1.221c.316.324.493.763.493 1.222v.074c0 .715-.566 1.295-1.263 1.295H5.263C4.566 19.41 4 18.83 4 18.114v-.074c0-.459.177-.898.493-1.222l1.191-1.221v-4.392C5.684 8.423 7.408 6 9.895 5.1 9.925 3.934 10.855 3 12 3z'
  />
)

export const Notification = createIcon({
  displayName: 'Notification',
  viewBox: '0 0 24 24',
  path: NotificationBase,
})
